import { CookieAttributes } from "js-cookie";

export const cookieAttributes: CookieAttributes =  process.env.NODE_ENV == "production" ? {
  domain: '.candorlanae.com',
  sameSite: 'none',
  secure: true
} : {}